
  const ReturnClassToken= {
    "AccessToken": "",
    "_jti": "",
    "ExpiresOn": "",
    "LoginID": "",
    "UserName": "",
    "FullName": "",
    "EmailID": "",
    "MobileNumber": "",
    "AddedOn": "",
    "UserID": "",
     "PartnerID": "",
    "IsSubAdmin": false,
    "IsFullRights": false,
    "OutMessage": ""
    
    
}
export default ReturnClassToken

